<template>
  <div class="footer-block">
    <!-- CONTENT 9 -->
    <b-container fluid class="content-box-berrier">
      <b-container>
        <b-row class="content-section text-center">
          <b-col cols="12"> </b-col>
        </b-row>
      </b-container>
    </b-container>
    <!-- CONTENT 9 -->
    <!-- CONTENT 9 -->
    <!--b-container fluid class="content-box-ready">
      <b-container>
        <b-row class="content-section text-center">
          <b-col
            cols="12"
            class="content-area"
            v-animate-onscroll="'animated zoomIn'"
          >
            <h2>{{$store.state.labels.LABEL_READY}}</h2>
            <div class="content-button">
              <b-button class="btn-blue text-upper"
                >{{$store.state.labels.BTN_GETIN_TOUCH}}
                </b-button
              >
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-container-->
    <!-- CONTENT 9 -->

    <!-- CONTENT 10 -->
    <b-container fluid class="content-box-magenta">
      <b-container>
        <b-row class="content-section" v-if="contents">
          <b-col cols="12" lg="6" class="content-area" v-animate-onscroll="'animated zoomIn'"
            v-for="(item, index) in contents" :key="'item' + index">
            <h2 :id="'footer-header-section-' + index" v-html="item.title"> </h2>
            <div :id="'footer-content-section-' + index" class="p-box">
              <p v-html="item.text"></p>
            </div>
            <div v-if="item.hyperlink != ''" class="content-button">
              <b-button @click="contactSales(item.hyperlink)" class="btn-magenta-white">{{ item.linkname }}</b-button>
            </div>
          </b-col>
        </b-row>
        <!--b-row class="content-section">
          <b-col
            cols="12"
            lg="6"
            class="content-area"
            v-animate-onscroll="'animated zoomIn'"
          >
            <h2 v-html="contentcontact.content_title"></h2>
            <div class="p-box">
            <p v-html="contentcontact.content_description"></p>
            </div>
            <div v-if="$route.name != 'Company'" class="content-button">
              <b-button @click="contactSales($store.state.configs.brand_email)" class="btn-magenta-white">{{$store.state.labels.BTN_GETIN_TOUCH}}</b-button>
            </div>
          </b-col>
          <b-col
            cols="12"
            lg="6"
            class="content-area"
            v-animate-onscroll="'animated zoomIn'"
          >
            <h2 v-html="contentsign.content_title"></h2>
            <div class="p-box">
            <p v-html="contentsign.content_description"></p>
            </div>
            <div v-if="$route.name != 'Company'" class="content-button">
              <b-button @click="contactSales($store.state.configs.brand_email)" class="btn-magenta-white">{{$store.state.labels.BTN_SIGN_UP}}</b-button>
            </div>
          </b-col>
        </b-row-->
      </b-container>
    </b-container>
    <!-- CONTENT 10 -->

    <!-- CONTENT 11 -->
    <b-container fluid class="content-box-footer">
      <b-container>
        <b-row class="content-section">
          <b-col cols="12" lg="3" class="content-area text-center">
            <b-img-lazy width="100" :src="$store.state.configs.brand_logo_color"
              :alt="$store.state.configs.brand_name"></b-img-lazy>
            <div>
              <h4 class="footer-h4">{{ $store.state.configs.brand_name }}</h4>
              <span class="footer-email">{{
                $store.state.configs.brand_email
              }}</span>
            </div>
            <b-img-lazy class="img-iso clearfix" src="https://www.sentineltech.com/assets/images/Sentec-ISO.png"
              alt="ISO"></b-img-lazy>
          </b-col>
          <b-col cols="12" lg="3" class="content-area">
            <h3>{{ $store.state.labels.MENU_SERVICES }}</h3>
            <ul>
              <li>
                <router-link :to="'/' + $store.state.selectlanguage + '/product/5/google-workspace'">{{
                  $store.state.labels.LABEL_GOOGLE_WORKSPACE }}</router-link>
              </li>
              <li>
                <router-link :to="'/' + $store.state.selectlanguage + '/product/7/pms'">{{ $store.state.labels.LABEL_PMS
                }}</router-link>
              </li>
              <li>
                <router-link :to="'/' + $store.state.selectlanguage + '/product/4/booking-engine'">{{
                  $store.state.labels.LABEL_BOOKING_ENGINE }}</router-link>
              </li>
              <li>
                <router-link :to="'/' + $store.state.selectlanguage + '/product/6/channel-manager'">{{
                  $store.state.labels.LABEL_CHANNEL_MANAGER }}</router-link>
              </li>
              <li>
                <router-link :to="'/' + $store.state.selectlanguage + '/product/8/cloud-server'">{{
                  $store.state.labels.LABEL_CLOUD_SERVER }}</router-link>
              </li>
            </ul>
          </b-col>
          <b-col cols="12" lg="3" class="content-area">
            <h3>{{ $store.state.labels.LABEL_USEFUL_LINKS }}</h3>
            <ul>
              <li>
                <router-link to="/">{{ $store.state.labels.LABEL_HOME }}</router-link>
              </li>
              <li>
                <span class="cursor-pointer" v-scroll-to="'#about-us'">{{ $store.state.labels.LABEL_ABOUT_US }}</span>
              </li>
              <!--li>
                <router-link to="/">{{$store.state.labels.LABEL_CUSTOMERS}}</router-link>
              </li-->
              <li>
                <span class="cursor-pointer" v-scroll-to="'#partner-list'">{{ $store.state.labels.LABEL_PARTNERS }}</span>
              </li>
              <li>
                <router-link :to="'/' + $store.state.selectlanguage + '/good-governance'">Good Governance</router-link>
              </li>
              <!--li>
                <router-link to="/">{{$store.state.labels.LABEL_LINKS}}</router-link>
              </li-->
            </ul>
          </b-col>
          <b-col cols="12" lg="3" class="content-area">
            <h3>{{ $store.state.labels.LABEL_CONTACTUS }}</h3>
            <b-alert v-if="isAlert" show dismissible fade>{{ formMessage }}</b-alert>
            <b-progress v-if="isLoading" :value="100" variant="success" striped :animated="animate"></b-progress>
            <b-form @submit="submitForm">
              <b-form-input v-model="formValue.full_name" :placeholder="$store.state.labels.LABEL_FULL_NAME"
                required></b-form-input>
              <b-form-input v-model="formValue.email" type="email" :placeholder="$store.state.labels.LABEL_EMAIL"
                required></b-form-input>
              <b-form-input v-model="formValue.phone" :placeholder="$store.state.labels.LABEL_CONTACT_NUMBER"
                required></b-form-input>
              <b-form-textarea v-model="formValue.message" :placeholder="$store.state.labels.LABEL_MESSAGE" rows="3"
                required></b-form-textarea>
              <b-button type="submit" class="btn-send"><b-icon icon="cursor-fill"></b-icon></b-button>
            </b-form>
          </b-col>
          <b-col cols="12" class="content-area">
            <div class="copyright text-center">
              <span v-html="$store.state.labels.LABEL_COPY_RIGHT"></span> &nbsp;
              <!--router-link to="/page/terms">{{$store.state.labels.LABEL_TERMS}}</router-link> |
              <router-link to="/page/privacy">{{$store.state.labels.LABEL_PRIVACY}}</router-link> |
              {{$store.state.labels.MENU_CONTACTUS}}-->
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-container>
    <!-- CONTENT 11 -->
  </div>
</template>

<script>
import { AppService } from './../service/main'
export default {
  name: "Footer",
  props: {
    /*
    contentcontact: {
      type: Object,
      default: () => [],
    },
    contentsign: {
      type: Object,
      default: () => [],
    },
    */
    contents: {},
  },
  data() {
    return {
      formValue: {
        full_name: "",
        email: "",
        phone: "",
        message: "",
      },
      isLoading: false,
      isAlert: false,
      formMessage: "",
      animate: true,
    };
  },
  methods: {
    async submitForm(event) {
      this.isLoading = true;
      event.preventDefault();
      if (
        this.formValue.full_name != "" &&
        this.formValue.email != "" &&
        this.formValue.phone != "" &&
        this.formValue.message != ""
      ) {
        var sendata = JSON.stringify(this.formValue);
        await AppService.submitForm('contactus', sendata)
          .then((response) => {
            if (response.status == "200") {
              this.formMessage = "Your message has been sent";
            } else {
              this.formMessage = "Failed!";
            }
            this.isLoading = false;
            this.isAlert = true;
          })
          .catch((e) => {
            console.log(e)
          })

      } else {
        alert("All fields required!");
      }
    },
    scrollMeTo(refName) {
      var element = this.$parent.$refs[refName];
      var top = element.offsetTop;

      window.scrollTo(0, top);
    },
    contactSales(link) {
      window.location = link;
    },
  },
};
</script>

<style>
.content-box-berrier {
  position: relative;
  min-height: 75px;
  overflow: hidden;
  text-align: left;
  background: #fff;
  /* border-top-left-radius: 50% 15%;
  border-top-right-radius: 50% 15%; */
}

.content-box-berrier:after {
  content: "";
  position: absolute;
  bottom: 0;
  right: -5%;
  left: -5%;
  height: 120px;
  background: #df27a5;
  -webkit-clip-path: ellipse(50% 50% at 50% 100%);
  clip-path: ellipse(50% 50% at 50% 100%);
}

/* ready */
.content-box-ready {
  position: relative;
  min-height: 275px;
  overflow: hidden;
  text-align: left;
  background: #f5f9fa;
  /* border-top-left-radius: 50% 15%;
  border-top-right-radius: 50% 15%; */
}

.content-box-ready:after {
  content: "";
  position: absolute;
  bottom: 0;
  right: -5%;
  left: -5%;
  height: 120px;
  background: #df27a5;
  -webkit-clip-path: ellipse(50% 50% at 50% 100%);
  clip-path: ellipse(50% 50% at 50% 100%);
}

.content-box-ready h2 {
  margin-top: 5px;
  color: #27a5f5;
  font-weight: bold;
}

.content-box-ready h2 span {
  color: #133d54;
}

.content-box-ready .content-section {
  margin-top: 5px;
  margin-bottom: 25px;
}

.content-box-ready .btn-blue {
  font-size: 0.9em;
  font-weight: 700;
  padding: 10px 20px;
  background: #3eb1f2;
  border: solid 1px #38aaeb;
  -webkit-box-shadow: 0px 11px 50px -10px rgba(62, 177, 242, 1);
  -moz-box-shadow: 0px 11px 50px -10px rgba(62, 177, 242, 1);
  box-shadow: 0px 11px 50px -10px rgba(62, 177, 242, 1);
}

.content-box-ready .btn-blue:hover {
  background: #309edb;
  border: solid 1px #38aaeb;
}

.content-box-ready .content-area {
  padding: 5px 30px;
}

.content-box-ready .content-button {
  margin-top: 25px;
}

/* ready */
/* magenta */
.content-box-magenta {
  position: relative;
  min-height: 400px;
  overflow: hidden;
  text-align: left;
  background: url("https://www.sentineltech.com/assets/images/Wave6.png") #df27a5;
  background-size: cover;
  /* margin-top: -65px;
  border-top-left-radius: 50% 15%;
  border-top-right-radius: 50% 15%; */
  color: #fff;
}

.content-box-magenta:after {
  content: "";
  position: absolute;
  bottom: 0;
  right: -5%;
  left: -5%;
  height: 120px;
  background: #000;
  -webkit-clip-path: ellipse(50% 50% at 50% 100%);
  clip-path: ellipse(50% 50% at 50% 100%);
}

.content-box-magenta h2 {
  margin-top: 30px;
  color: #fff;
  font-weight: bold;
}

.content-box-magenta h2 span {
  color: #133d54;
}

.content-box-magenta .content-section {
  margin-top: 5px;
  margin-bottom: 25px;
}

.content-box-magenta .content-area {
  padding: 5px 100px;
}

.content-box-magenta .content-area p {
  font-size: 0.9em;
}

.btn-magenta-white {
  font-size: 1.1em;
  padding: 12px 21px;
  background: none;
  border: solid 1px #fff;
  color: #fff;
  -webkit-border-radius: 25px !important;
  -moz-border-radius: 25px !important;
  border-radius: 25px !important;
  width: 200px;
}

.btn-magenta-white:hover {
  background: rgba(150, 150, 150, 0.1);
  border: solid 1px #fff;
  color: #fff;
}

/* magenta */
/* footer */
.content-box-footer {
  position: relative;
  min-height: 400px;
  overflow: hidden;
  text-align: left;
  background: #000;
  /* margin-top: -70px; */
  color: #fff;
}

.content-box-footer h2 {
  margin-top: 30px;
  color: #fff;
  font-weight: bold;
}

.content-box-footer h2 span {
  color: #133d54;
}

.content-box-footer .content-section {
  margin-top: 50px;
  margin-bottom: 25px;
}

.content-box-footer .content-area {
  padding: 0;
}

.content-box-footer h3 {
  font-size: 1.2em;
  color: #3eb1f2;
}

.content-box-footer ul {
  margin-left: 0;
  padding-left: 0;
}

.content-box-footer ul li {
  list-style: none;
  padding-left: 0;
  margin: 7px 0;
}

.content-box-footer ul li a,
.content-box-footer ul li a:hover {
  color: #fff;
  text-decoration: none;
}

/* footer */
.form-control {
  margin: 6px 0;
  background: #262626;
  border: none;
  color: #fff !important;
}

.form-control:focus {
  background: #262626;
}

.btn-send {
  background: #383838;
  color: #ff1493;
  border: none;
  margin: 0;
  -webkit-border-top-left-radius: 15px !important;
  -webkit-border-top-right-radius: 3px !important;
  -webkit-border-bottom-right-radius: 15px !important;
  -webkit-border-bottom-left-radius: 2px !important;
  -moz-border-radius-topleft: 15px !important;
  -moz-border-radius-topright: 3px !important;
  -moz-border-radius-bottomright: 15px !important;
  -moz-border-radius-bottomleft: 2px !important;
  border-top-left-radius: 15px !important;
  border-top-right-radius: 3px !important;
  border-bottom-right-radius: 15px !important;
  border-bottom-left-radius: 2px !important;
}

.btn-send:hover {
  background: #242424;
}

.copyright {
  font-size: 14px;
  color: #373737;
  margin: 30px 0 10px;
}

.copyright a,
.copyright a:hover {
  color: #373737;
  text-decoration: none;
}

.footer-h4 {
  font-size: 1.4em;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 10px;
}

.footer-email {
  font-size: 0.9em;
}

.text-upper {
  text-transform: uppercase;
}

.alert-dismissible .close {
  padding: 0rem 1.25rem !important;
}

.cursor-pointer {
  cursor: pointer;
}

.p-box {
  min-height: 80px;
}

.img-iso {
  margin-top: 20px;
}

.clearfix {
  clear: both;
}

@media (max-width: 768px) {
  .content-box-ready {}

  .content-box-magenta .content-area {
    padding: 0 10px;
  }

  .content-box-magenta {
    min-height: 570px;

    background-size: 100% 100%;
  }

  .content-box-footer {}

  .content-box-footer .content-area {
    margin-bottom: 50px;
  }

  .content-box-berrier:after {
    -webkit-clip-path: ellipse(50% 25% at 50% 100%);
    clip-path: ellipse(50% 25% at 50% 100%);
  }

  .content-box-ready:after {
    -webkit-clip-path: ellipse(50% 25% at 50% 100%);
    clip-path: ellipse(50% 25% at 50% 100%);
  }

  .content-box-magenta:after {
    -webkit-clip-path: ellipse(50% 25% at 50% 100%);
    clip-path: ellipse(50% 25% at 50% 100%);
  }
}
</style>
